export default __webpack_public_path__ + "static/seo-agentur-stuttgart-intro-411c2e3aafed386004679eea0818b036.mp4";